export default {"src":"/_next/static/media/vue.f7fc640e.svg","height":2158,"width":2500,"blurWidth":0,"blurHeight":0};